module.exports = __webpack_public_path__ + "img/a4.3eecc7ad.png";